/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { register } from 'swiper/element/bundle';

// Register Swiper custom elements globally
register();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
